export default __webpack_public_path__ + "static/media/whatsapp.9c3b8fcc.png";